import PropTypes from "prop-types";
import { useSystemBanner } from "@hooks/shared/use-system-banner";
import { SystemBannerBar } from "./system-banner-bar";

// The tenant-wide notice (ADR-0051) wherever a layout places it. Renders nothing when there
// is no banner, outside its display window, or once the reader dismissed it.
export const SystemBanner = ({ signIn = false, sx }) => {
  const banner = useSystemBanner({ signIn });
  if (!banner) return null;
  return <SystemBannerBar {...banner} sx={sx} />;
};

SystemBanner.propTypes = {
  // The sign-in screen: the boot-time banner, and only when it is meant for that screen.
  signIn: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
